

























import { defineComponent, computed } from "@vue/composition-api";

import { getSalutationTitle, getBranchTypeTitle } from "@/api/sap";
import store from "@/store";

import {
  RegistrationOverviewDataTable,
  RegistrationOverviewTextWithIconIndicator,
} from "../../../RegistrationOverview";

export default defineComponent({
  name: "RegistrationPersonalDetailsStepOverview",
  components: {
    RegistrationOverviewDataTable,
    RegistrationOverviewTextWithIconIndicator,
  },
  setup() {
    const isBusinessCustomer = computed(
      () => store.getters.registrationRouteIsBusinessCustomer
    );

    const registrationPersonalDetailsStepData = computed(
      () =>
        store.state.registrationRoute.formData.registrationPersonalDetailsStep
    );

    const details = computed(() =>
      [
        {
          title: "Anrede",
          value:
            (isBusinessCustomer.value
              ? getSalutationTitle(
                  registrationPersonalDetailsStepData.value
                    .contactPersonSalutation
                )
              : getSalutationTitle(
                  registrationPersonalDetailsStepData.value.salutation
                )) ?? "",
        },
        {
          title: "Vorname/Nachname",
          value:
            registrationPersonalDetailsStepData.value.firstName &&
            registrationPersonalDetailsStepData.value.lastName &&
            `${registrationPersonalDetailsStepData.value.firstName} ${registrationPersonalDetailsStepData.value.lastName}`,
        },
        {
          title: "Geburtsdatum",
          value: registrationPersonalDetailsStepData.value.birthDate
            ?.split("-")
            .reverse()
            .join(" / "),
        },
        {
          title: "Tel.",
          value: registrationPersonalDetailsStepData.value.phone,
        },
        {
          title: "E-Mail",
          value: registrationPersonalDetailsStepData.value.emailAddress,
        },
        {
          title: "Kundennummer des Werbenden",
          value: registrationPersonalDetailsStepData.value.accountCustomer,
        },
      ].filter((item) => !!item.value)
    );

    const companyDetails = computed(() =>
      [
        // {
        //   title: "Anrede",
        //   value: getSalutationTitle(
        //     registrationPersonalDetailsStepData.value.salutation
        //   ),
        // },
        {
          title: "Firmenname",
          value: registrationPersonalDetailsStepData.value.companyName,
        },
        {
          title: "Firmenzusatz",
          value: registrationPersonalDetailsStepData.value.companySuffix,
        },
        {
          title: "Branche",
          value: getBranchTypeTitle(
            registrationPersonalDetailsStepData.value.branchType
          ),
        },
      ].filter((item) => !!item.value)
    );

    return {
      isBusinessCustomer,
      details,
      companyDetails,
    };
  },
});
